import axios from "axios";
import { formatStoreError as _formatStoreError } from "@/lib/storefront";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CUSTOMER_TOKEN_KEY = "customer_access_token_v1";

/**
 * JWT format validator — only forwards strings shaped like `xxx.yyy.zzz`
 * to the Authorization header. Defends against malicious extensions or
 * console-injected localStorage values being sent server-side.
 */
const JWT_RE = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
function readCustomerToken() {
  try {
    if (typeof window === "undefined") return null;
    const raw = localStorage.getItem(CUSTOMER_TOKEN_KEY);
    if (!raw || typeof raw !== "string") return null;
    if (raw.length > 4096) return null;
    return JWT_RE.test(raw) ? raw : null;
  } catch {
    return null;
  }
}

/** Customer-side API client. Adds Bearer token from localStorage if present. */
export const customerApi = axios.create({
  baseURL: `${BACKEND_URL}/api/customer/auth`,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

customerApi.interceptors.request.use((config) => {
  const token = readCustomerToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatStoreError = _formatStoreError;
